<h4 mat-dialog-title></h4>

<mat-dialog-content>
    <customer-status-checklist-old [customerId]="data.customerId" [customerStatusId]="data.customerStatusId"
                                   [customerActionId]="data.customerActionId">Loading</customer-status-checklist-old>
</mat-dialog-content>

<mat-dialog-actions>
    <button class="epi-button" (click)="cancel()" style="float: right">Close</button>
</mat-dialog-actions>
